<template>
  <v-flex
    v-if="getConsentsQuestions"
    id="consents"
    class="question"
  >
    <h2 class="display-3 display-3_dark">
      {{ getConsentsQuestions?.label }}
    </h2>
    <p
      v-for="(text, index) in getConsentsQuestions?.text"
      :key="index"
      class="mb-0 f-1"
    >
      {{ text }}
    </p>
    <ul class="questions-list">
      <li
        v-if="getConsentsQuestions?.hasOwnProperty('gift_giver_contact')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getConsentsQuestions.gift_giver_contact?.required }"
        >
          {{ getConsentsQuestions.gift_giver_contact?.label }}
        </p>
        <ConfirmButtons
          v-model="giftGiverContact"
          v-validate="{ required: getConsentsQuestions.gift_giver_contact?.required }"
          string
          :error-messages="errors.collect('giftGiverContact')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'giftGiverContact'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="getConsentsQuestions?.hasOwnProperty('preliminary_media_contact')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getConsentsQuestions.preliminary_media_contact?.required }"
        >
          {{ getConsentsQuestions.preliminary_media_contact?.label }}
        </p>
        <ConfirmButtons
          v-model="preliminaryMediaContact"
          v-validate="{ required: getConsentsQuestions.preliminary_media_contact?.required }"
          string
          :error-messages="errors.collect('preliminaryMediaContact')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'preliminaryMediaContact'"
          :disabled="readOnly"
        />
        <p
          v-for="(text, index) in getConsentsQuestions.preliminary_media_contact?.text"
          :key="index"
          class="f-14 mt-2 mb-4 font-italic font-weight-regular"
        >
          {{ text }}
        </p>
      </li>
      <li
        v-if="getConsentsQuestions?.hasOwnProperty('meetings_after_final')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getConsentsQuestions.meetings_after_final?.required }"
        >
          {{ getConsentsQuestions.meetings_after_final?.label }}
        </p>
        <ConfirmButtons
          v-model="meetingsAfterFinal"
          v-validate="{ required: getConsentsQuestions.meetings_after_final?.required }"
          string
          :error-messages="errors.collect('meetingsAfterFinal')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'meetingsAfterFinal'"
          :disabled="readOnly"
        />
        <p
          v-for="(text, index) in getConsentsQuestions.meetings_after_final?.text"
          :key="index"
          class="f-14 mt-2 mb-4 font-italic font-weight-regular"
        >
          {{ text }}
        </p>
      </li>
      <li
        v-if="getConsentsQuestions?.hasOwnProperty('personal_data')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getConsentsQuestions.personal_data?.required }"
        >
          {{ getConsentsQuestions.personal_data?.label }}
        </p>
        <ConfirmButtons
          v-model="personalData"
          v-validate="{ required: getConsentsQuestions.personal_data?.required }"
          string
          :error-messages="errors.collect('personalData')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'personalData'"
          :disabled="readOnly"
        />
      </li>
      <SheetQuestion
        v-if="getConsentsQuestions?.hasOwnProperty('could_family_story_be_presented_in_media')"
        :label="getConsentsQuestions?.could_family_story_be_presented_in_media?.label"
        :required="getConsentsQuestions?.could_family_story_be_presented_in_media?.required"
        :help-text="getConsentsQuestions?.could_family_story_be_presented_in_media?.text"
      >
        <ConfirmButtons
          v-model="couldFamilyStoryBePresentedInMedia"
          v-validate="{
            required: getConsentsQuestions?.could_family_story_be_presented_in_media?.required
          }"
          string
          :error-messages="errors.collect('couldFamilyStoryBePresentedInMedia')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'couldFamilyStoryBePresentedInMedia'"
          :disabled="readOnly"
        />
      </SheetQuestion>
      <SheetQuestion
        v-if="getConsentsQuestions?.hasOwnProperty('media_disclosure_agreement')"
        :label="getConsentsQuestions?.media_disclosure_agreement?.label"
        :required="getConsentsQuestions?.media_disclosure_agreement?.required"
        :help-text="getConsentsQuestions?.media_disclosure_agreement?.text"
      >
        <ConfirmButtons
          v-model="mediaDisclosureAgreement"
          v-validate="{ required: getConsentsQuestions?.media_disclosure_agreement?.required }"
          string
          :error-messages="errors.collect('mediaDisclosureAgreement')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'mediaDisclosureAgreement'"
          :disabled="readOnly"
        />
      </SheetQuestion>
    </ul>
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';

import { mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import SheetQuestion from '@/components/sheet/SheetQuestion';

const { mapFields } = createHelpers({
    getterType: 'sheet/getConsentsField',
    mutationType: 'sheet/updateConsentsField'
});

export default {
    name: 'SheetOneConsents',
    components: { ConfirmButtons, SheetQuestion },
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        ...mapFields([
            'personalData',
            'meetingsAfterFinal',
            'giftGiverContact',
            'preliminaryMediaContact',
            'mediaDisclosureAgreement',
            'couldFamilyStoryBePresentedInMedia'
        ]),
        ...mapGetters('sheet', ['getConsentsQuestions'])
    }
};
</script>

<style scoped></style>
